export const AWS_FILE_TYPES = Object.freeze({
  FILE: 'FILE',
  AVATAR: 'AVATAR',
  CDN: 'CDN',
});
